// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var $$Array = require("rescript/lib/js/array.js");
var Curry = require("rescript/lib/js/curry.js");
var Belt_List = require("rescript/lib/js/belt_List.js");
var JsxRuntime = require("react/jsx-runtime");
var Mode$ReactHooksTemplate = require("./mode.res.js");
var CheckboxInput$ReactHooksTemplate = require("../common/CheckboxInput.res.js");

function FollowUpSurveyMode(props) {
  var modeView = props.modeView;
  var removeFollowUpMode = props.removeFollowUpMode;
  var addFollowUpMode = props.addFollowUpMode;
  var hasFollowUpMode = props.hasFollowUpMode;
  var campaignModes = props.campaignModes;
  return JsxRuntime.jsxs("div", {
              children: [
                JsxRuntime.jsx("div", {
                      children: JsxRuntime.jsx("span", {
                            children: "Follow Up Modes",
                            className: "font-semibold text-gray-700 text-sm"
                          }),
                      className: "mb-8 mt-9"
                    }),
                JsxRuntime.jsx("div", {
                      children: Belt_List.length(campaignModes) > 0 ? $$Array.of_list(Belt_List.map(campaignModes, (function (mode) {
                                    return JsxRuntime.jsxs("div", {
                                                children: [
                                                  JsxRuntime.jsx("div", {
                                                        children: JsxRuntime.jsx(CheckboxInput$ReactHooksTemplate.make, {
                                                              checked: Curry._1(hasFollowUpMode, Mode$ReactHooksTemplate.modeType(mode)),
                                                              label: Mode$ReactHooksTemplate.modeType(mode),
                                                              handleChange: (function (param) {
                                                                  if (Curry._1(hasFollowUpMode, Mode$ReactHooksTemplate.modeType(mode))) {
                                                                    return Curry._1(removeFollowUpMode, Mode$ReactHooksTemplate.modeType(mode));
                                                                  } else {
                                                                    return Curry._1(addFollowUpMode, Mode$ReactHooksTemplate.modeType(mode));
                                                                  }
                                                                }),
                                                              checkboxClassName: "blue_checkbox"
                                                            }),
                                                        className: "flex items-center justify-between"
                                                      }),
                                                  Curry._1(hasFollowUpMode, Mode$ReactHooksTemplate.modeType(mode)) ? Curry._1(modeView, Mode$ReactHooksTemplate.modeType(mode)) : null
                                                ],
                                                className: "border-b border-gray-100 pb-4 last:border-b-0"
                                              }, Mode$ReactHooksTemplate.modeType(mode));
                                  }))) : JsxRuntime.jsx("div", {
                              children: "No follow-up modes available",
                              className: "text-sm text-gray-500 italic"
                            }),
                      className: "space-y-4"
                    })
              ]
            });
}

var make = FollowUpSurveyMode;

exports.make = make;
/* react/jsx-runtime Not a pure module */
